import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LayoutProvider } from './context/LayoutContext';
import Layout from './components/layout/Layout';
import Home from './pages/recruiter/Home';
import Confirmation from './pages/applicant/Confirmation';
import QuestionnaireBuilder from './pages/recruiter/QuestionnaireBuilder';
import Onboarding from './pages/applicant/Onboarding';
import Interview from './pages/applicant/Interview';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from './pages/common/NotFound';
import ProtectedRoute from './protectedRoutes/ProtectedRoute';
import UnauthorizedPage from './pages/common/UnauthorizedPage';
import AudioInterview from './pages/applicant/AudioInterview';
import InterviewCompleted from './pages/applicant/InterviewCompleted';
function App() {
  return (
    <div className="App">
      <LayoutProvider>
        <BrowserRouter basename="/v1">
          <Routes>
            {/* Recruiter routes */}
            <Route path="/recruiter" element={<Layout userType="recruiter" />}>
              <Route index element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } />
              <Route path="questionnaire-builder/:questionnaireId?" element={
                <ProtectedRoute>
                  <QuestionnaireBuilder />
                </ProtectedRoute>} />
              <Route path="unauthorized" element={<UnauthorizedPage />} />
            </Route>
            
            {/* Interview routes */}
            <Route path="/interview" element={<Layout />}>
              <Route path="questionnaire-builder/:questionnaireId" element={<QuestionnaireBuilder />} />
              <Route path="onboarding/:applicantGuid" element={<Onboarding />} />
              <Route path="questions" element={<Interview />} />
              <Route path="questions/audio" element={<AudioInterview />} />
              <Route path="success" element={<Confirmation />} />
              <Route path="already-completed" element={<InterviewCompleted />} />
            </Route>
            
            {/* Catch-all route */}
            <Route path="*" element={<NotFound/>} />
          </Routes>
        </BrowserRouter>
      </LayoutProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
